import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const DataStatPrintSummary = ({
  value,
  label,
  description = null,
  primaryBrand,
}): JSX.Element => {

  return (
    <View>
      <View>
        <Text
          style={{
            fontFamily: 'Courier-Bold',
            fontSize: 8,
            color: primaryBrand.colors.dark,
          }}
        >
          {label}
        </Text>
      </View>
      <View>
        <Text
          style={{
            fontFamily: 'Helvetica-Bold',
            fontSize: 24,
            lineHeight: 1,
            color: primaryBrand.colors.primary,
          }}
        >
          {value}
        </Text>
        { description &&
          <Text style={{
            fontFamily: 'Helvetica',
            fontSize: 9,
            marginTop: 2.25,
          }}>{description}</Text>
        }
      </View>
    </View>
  );
};

export default DataStatPrintSummary;
